export enum AuthorizedEnterpriseActionTypes {
  API_RESPONSE_SUCCESS = '@@authorizedEnterprise/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@authorizedEnterprise/API_RESPONSE_ERROR',

  LIST_AUTHORIZEDENTERPRISES = '@@authorizedEnterprise/LIST_AUTHORIZEDENTERPRISE',

  RESET = '@@authorizedEnterprise/RESET',
}